


export type FlowConfigurationAuditKind = 'Assignment' | 'Role' | 'AccountGroup' | 'AssignmentRule' | 'BillingPeriod' | 'Deadline' | 'Substitution';

export const FlowConfigurationAuditKind = {
    Assignment: 'Assignment' as FlowConfigurationAuditKind,
    Role: 'Role' as FlowConfigurationAuditKind,
    AccountGroup: 'AccountGroup' as FlowConfigurationAuditKind,
    AssignmentRule: 'AssignmentRule' as FlowConfigurationAuditKind,
    BillingPeriod: 'BillingPeriod' as FlowConfigurationAuditKind,
    Deadline: 'Deadline' as FlowConfigurationAuditKind,
    Substitution: 'Substitution' as FlowConfigurationAuditKind
};

